<template>
  <v-navigation-drawer
    :value="isAddEditSidebarActive"
    temporary
    touchless
    :right="true"
    :width="$vuetify.breakpoint.smAndUp ? 450 : '100%'"
    app
    @input="(val) => $emit('update:is-add-edit-sidebar-active', val)"
  >
    <v-card height="100%">
      <div class="drawer-header d-flex align-center mb-4">
        <span class="font-weight-semibold text-base text--primary">{{ isEditMode ? 'Actualizar' : 'Agregar' }}</span>
        <v-spacer></v-spacer>
        <v-btn
          icon
          small
          @click="$emit('update:is-add-edit-sidebar-active',false)"
        >
          <v-icon size="22">
            {{ icons.mdiClose }}
          </v-icon>
        </v-btn>
      </div>

      <v-card-text>
        <v-form
          ref="form"
          v-model="valid"
          @submit.prevent="onSubmit"
        >
          <h2>{{ itemData.name }}</h2>
          <!-- #### Price ############## -->
          <v-text-field
            v-model="itemData.price"
            outlined
            dense
            :rules="[validators.required, validators.decimal]"
            label="Precio"
            placeholder="Precio"
            hide-details="auto"
            type="number"
            class="mb-6"
          ></v-text-field>

          <v-btn
            :color="isEditMode ? 'info' : 'primary'"
            class="me-3"
            type="submit"
          >
            {{ isEditMode ? 'Actualizar' : 'Agregar' }}
          </v-btn>
          <v-btn
            color="secondary"
            outlined
            type="reset"
            @click="resetItemData"
          >
            Cancelar
          </v-btn>
        </v-form>
      </v-card-text>
    </v-card>
  </v-navigation-drawer>
</template>

<script>
import { mdiClose } from '@mdi/js'
import { ref } from '@vue/composition-api'
import { required, decimal } from '@core/utils/validation'
import store from '@/store'

export default {
  model: {
    prop: 'isAddEditSidebarActive',
    event: 'update:is-add-edit-sidebar-active',
  },
  props: {
    isAddEditSidebarActive: {
      type: Boolean,
      required: true,
    },
  },
  setup(_, { emit }) {
    const isEditMode = ref(false)

    const blankItemData = {
      calendlyId: null,
      name: null,
      price: null,
      active: false,
    }

    const valid = ref(false)
    const form = ref(null)

    const validate = () => {
      form.value.validate()
    }

    const resetForm = () => {
      form.value.reset()
    }

    const itemData = ref(JSON.parse(JSON.stringify(blankItemData)))

    const resetItemData = () => {
      itemData.value = JSON.parse(JSON.stringify(blankItemData))
      resetForm()
      emit('update:is-add-edit-sidebar-active', false)
      isEditMode.value = false
    }

    const onSubmit = () => {
      if (valid.value) {
        let mode = 'Insert'
        if (isEditMode.value === true) {
          mode = 'Update'
        }
        store.dispatch('events/apiCall', { mode, request: itemData.value }).then(result => {
          if (result.success) {
            emit('refetch-data')
            emit('update:is-add-edit-sidebar-active', false)
            resetItemData()
          }
        })
      } else {
        validate()
      }
    }

    const ShowEditDialog = key => {
      store.dispatch('events/apiCall', { mode: 'Select', request: { key } }).then(result => {
        if (result.success) {
          itemData.value = result.data
          emit('update:is-add-edit-sidebar-active', true)
          isEditMode.value = true
        }
      })
    }

    return {
      isEditMode,
      resetItemData,
      form,
      onSubmit,
      itemData,
      valid,
      validate,
      ShowEditDialog,

      // validation
      validators: { required, decimal },
      icons: { mdiClose },
    }
  },
}
</script>
